/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
const SearchResults = ({
  entries
}) => {
  if (entries.length < 1) {
    return null;
  }
  return /*#__PURE__*/React.createElement("ul", {
    className: "ebds-search-results"
  }, entries.map(entry => /*#__PURE__*/React.createElement("li", {
    className: "ebds-search-results__item",
    key: entry.url
  }, /*#__PURE__*/React.createElement("div", {
    className: "ebds-search-results__item__title"
  }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement("a", {
    href: entry.url,
    tabIndex: "-1"
  }, entry.title)), /*#__PURE__*/React.createElement("p", {
    className: "ebds-search-results__item__title__meta"
  }, /*#__PURE__*/React.createElement("a", {
    href: entry.url,
    tabIndex: "-1"
  }, entry.url))), /*#__PURE__*/React.createElement("div", {
    className: "ebds-search-results__item__content"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
    href: entry.url,
    dangerouslySetInnerHTML: {
      __html: entry.teaser
    }
  }))))));
};
export default SearchResults;